"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_SERVER_PORT = exports.MGMT_SERVER_PORT = exports.DEFAULT_APPFW_APPNAME = exports.SHUTDOWN_WAITING_TIME = exports.LMN_ENVIRONMENTS = exports.HEADER_NAME_TRACEPARENT = exports.HEADER_NAME_METHOD_NAME = exports.HEADER_NAME_SPAN_ID = exports.HEADER_NAME_TRACE_ID = exports.HEADER_NAME_HOST_ID = exports.HEADER_NAME_APP_NAME = exports.HEADER_NAME_MPT = void 0;
exports.HEADER_NAME_MPT = 'X-LM-Multipurpose-Token';
exports.HEADER_NAME_APP_NAME = 'X-BF-tracing-appName';
exports.HEADER_NAME_HOST_ID = 'X-BF-tracing-hostId';
exports.HEADER_NAME_TRACE_ID = 'X-BF-tracing-traceId';
exports.HEADER_NAME_SPAN_ID = 'X-BF-tracing-spanId';
exports.HEADER_NAME_METHOD_NAME = 'X-BF-tracing-methodName';
exports.HEADER_NAME_TRACEPARENT = 'traceparent';
var LMN_ENVIRONMENTS;
(function (LMN_ENVIRONMENTS) {
    LMN_ENVIRONMENTS["production"] = "production";
    LMN_ENVIRONMENTS["qa"] = "qa";
    LMN_ENVIRONMENTS["local"] = "local";
})(LMN_ENVIRONMENTS || (exports.LMN_ENVIRONMENTS = LMN_ENVIRONMENTS = {}));
/**
 * Time to wait (in milliseconds) between readiness check going DOWN and actually shutting down servers.
 * This gives time for load balancers/Kubernetes to stop sending traffic.
 */
exports.SHUTDOWN_WAITING_TIME = 29_000;
exports.DEFAULT_APPFW_APPNAME = 'nextjs-appfw-default';
exports.MGMT_SERVER_PORT = 8082;
exports.APP_SERVER_PORT = 8081;
